var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#6A6868",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6 15.9C0.7 16 0.9 16 1 16H4C4.6 16 5 15.6 5 15C5 14.4 4.6 14 4 14H3.4L6.7 10.7C7.1 10.3 7.1 9.7 6.7 9.3C6.3 8.9 5.7 8.9 5.3 9.3L2 12.6V12C2 11.4 1.6 11 1 11C0.4 11 0 11.4 0 12V15C0 15.1 -9.68575e-08 15.3 0.0999999 15.4C0.2 15.6 0.4 15.8 0.6 15.9Z",
    fill: "#6A6868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 12.7C11.5 12.9 11.8 13 12 13C12.2 13 12.5 12.9 12.7 12.7C13.1 12.3 13.1 11.7 12.7 11.3L4.7 3.3C4.3 2.9 3.7 2.9 3.3 3.3C2.9 3.7 2.9 4.3 3.3 4.7L11.3 12.7Z",
    fill: "#6A6868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10.3 7 10.5 6.9 10.7 6.7L14 3.4V4C14 4.6 14.4 5 15 5C15.6 5 16 4.6 16 4V1C16 0.9 16 0.7 15.9 0.6C15.8 0.4 15.6 0.2 15.4 0.0999999C15.3 -9.68575e-08 15.1 0 15 0H12C11.4 0 11 0.4 11 1C11 1.6 11.4 2 12 2H12.6L9.3 5.3C8.9 5.7 8.9 6.3 9.3 6.7C9.5 6.9 9.7 7 10 7Z",
    fill: "#6A6868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.ca9e6d802561137e97e21a87a8f70c2e.svg";
export { ForwardRef as ReactComponent };